import { } from "jquery"
import * as JsBarcode from 'jsbarcode'
import { chunk } from "lodash"
import { AssetBarcodeData } from "../api/model"
import * as url from "url"
import { UiUtils } from "./ui"

export class ExportAssetBarcodePage {
    rootContainerId: string = "export_asset_barcode_container"
    id: string

    constructor() {
        this.id = url.parse(location.href, true).query['id']
    }

    fillBarcodes() {
        const commInfo = JSON.parse(localStorage.getItem('community_info'))
        const containerElm = $(`#${this.rootContainerId}`)
        const barcodeElmText = '<svg class="barcode" jsbarcode-height="45" jsbarcode-fontSize="14" jsbarcode-textPosition="bottom"  jsbarcode-textmargin="4"  ></svg>'
        const barcodeData = this.getCurrentData()
        chunk(barcodeData, 4).forEach((barcodeData, rowNum) => {
            /*為符合標籤貼紙格式列印修正 每10列為1頁*/
            if (rowNum % 10 == 0)
            {
                const wrapElm = $('<div class="wrap page' +(rowNum / 10)+'"></div>');
                containerElm.append(wrapElm);
            }            
            const rowElm = $('<div class="row"></div>')
            barcodeData.forEach(data => {
                const barcodeElm = $(barcodeElmText).attr('jsbarcode-value', data.displayId)
                const title1Elm = $('<div class="barcode_title1"></div>').append(commInfo.name)
                const title2Elm = $('<div class="barcode_title2"></div>').append(data.name) 
                const title3Elm = $('<div class="barcode_title3"></div>')
                if(data.communityAssignId != null){
                    title3Elm.append(data.communityAssignId) 
                    barcodeElm.attr('jsbarcode-height', 29) 
                }

                const colWrapElm = $('<div class="barcode_col"></div>')
                    .append(title1Elm)
                    .append(title2Elm)
                    .append(title3Elm)
                    .append(barcodeElm)
                //.append($('<div class="barcode_num"></div>').append(data.displayId))
                const colElm = $('<div class="col-xs-3" style="margin-top:7px;margin-bottom:7px;"></div>').append(colWrapElm)
                rowElm.append(colElm)
            })
            containerElm.append(rowElm)
            containerElm.find(".wrap.page" + Math.floor(rowNum / 10)).append(rowElm);     
        })
        JsBarcode(".barcode").init()
        $('.barcode text').toArray().map($).forEach((elm, index) => {
            const text = elm.text() + ' ' + barcodeData[index].areaName.substr(0, 7)
            elm.text(text)
        })
    }

    async showPrint(){
        const toPrint = await UiUtils.confirm("是否列印此頁")
        if(toPrint){
            window.print()
        }
    }

    getCurrentData(): Array<AssetBarcodeData> {
        const dataStr = localStorage.getItem('barcode_tmp')
        if (dataStr) {
            const data = JSON.parse(dataStr)
            const sdata = data[this.id]
            if (sdata != null) {
                $('.wait').hide()
                return sdata
            }
        }
        return []
    }
}
